import { render, staticRenderFns } from "./outputRecord.vue?vue&type=template&id=09387089&scoped=true"
import script from "./outputRecord.vue?vue&type=script&lang=js"
export * from "./outputRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09387089",
  null
  
)

export default component.exports